module.exports = __webpack_public_path__ + "static/img-contacto-b18fdff093f98fedcb5de4832c875710.webp";